import { Tooltip as TooltipElement } from '@dixa/lib-shared-habla';
import {
  createElement,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from 'react';

import type {
  EditorContextUIHandlers,
  Tooltip,
} from 'flow-builder/types/context';

type UseTooltipReturn = {
  tooltip: ReactNode;
  onTooltipShow: EditorContextUIHandlers['onTooltipShow'];
  onTooltipHide: EditorContextUIHandlers['onTooltipHide'];
};

export function useTooltip(): UseTooltipReturn {
  const [tooltipState, setTooltipState] = useState<Tooltip | null>(null);

  const onTooltipShow = useCallback<EditorContextUIHandlers['onTooltipShow']>(
    setTooltipState,
    [setTooltipState],
  );

  const onTooltipHide = useCallback<
    EditorContextUIHandlers['onTooltipHide']
  >(() => {
    setTooltipState(null);
  }, [setTooltipState]);

  const tooltip = useMemo(
    () =>
      tooltipState
        ? createElement(
            TooltipElement,
            {
              wrap: 'none',
              head: tooltipState.head,
              content: tooltipState.content,
              alwaysShow: true,
            },
            createElement('div', {
              style: {
                position: 'absolute',
                top: tooltipState.position.y,
                left: tooltipState.position.x,
              },
            }),
          )
        : null,
    [tooltipState],
  );

  return {
    tooltip,
    onTooltipShow,
    onTooltipHide,
  };
}
